export default __webpack_public_path__ + "static/media/plataforma_textura1.0624faf2.svg";